<template>
<div>
    <!-- <iframe width="560" height="315" src="https://www.youtube.com/embed/Ae-aV57z70M" frameborder="0" allowfullscreen></iframe> -->
    <div class="main_members_horizontal">
        <Member v-for="member in this.members" :member="member" :key="member.twitter" :small="false" :swaying="true"/>
    </div>
    <br/>
    <div class="main_grid">
        <GameCard v-for="game in this.games" :game="game" :key="game.id"/>
    </div>
    <GameGif/>
    <GameInfo/>
  </div>
</template>

<script>
  import data from '../data'
  import GameCard from './GameCard.vue'
  import Member from './Member.vue'
  import GameGif from './GameGif.vue'
  import GameInfo from './GameInfo.vue'
  import Masonry from 'masonry-layout'
  
  export default {
    components: {
      GameCard,
      Member,
      GameGif,
      GameInfo
    },
    methods: {
      displayDetails (id) {
        this.$router.push({name: 'detail', params: { id: id }})
      }
    },
    data () {
      function shuffleArray (array) {
        for (let i = array.length - 1; i > 0; i--) {
          let j = Math.floor(Math.random() * (i + 1));
          [array[i], array[j]] = [array[j], array[i]]
        }
      }
      let gamesList = []
      var factor = 1
      for (let i = 0; i < data.games.length * factor; i++) {
        var game = Object.assign({}, data.games[i % data.games.length])
        var maxsize = 1
        var rnd = Math.random()
        if (rnd > 0.8) {
          maxsize = 3
        } else if (rnd > 0.5) {
          maxsize = 2
        }
        // jednak bez 3
        // maxsize = Math.min(maxsize, 2)
        if (game['size'] === undefined) {
          game['size'] = 'box' + Math.ceil(Math.random() * maxsize)
        }
        game['posx'] = 20 + Math.ceil(Math.random() * 30)
        game['posy'] = 20 + Math.ceil(Math.random() * 30)
        gamesList.push(game)
      }
      shuffleArray([])
      let members = []
      for (var i = 0; i < data.members.length; i++) {
        members.push(Object.assign({}, data.members[i]))
      }
      shuffleArray(members)
      let membersLeft = []
      let membersRight = []
      for (i = 0; i < members.length; i++) {
        if (i % 2 === 0) {
          membersLeft.push(members[i])
        } else {
          membersRight.push(members[i])
        }
      }
      return {
        'games': gamesList,
        'membersLeft': membersLeft,
        'membersRight': membersRight,
        'members': members
      }
    },
    mounted: function () {
      this.$nextTick(function () {
        var msnry = new Masonry('.main_grid', {
          itemSelector: '.card',
          columnWidth: 166
        })
        msnry.layout()
      })
    }
  }
</script>


<style scoped>
  .main_members_horizontal {
    display: flex;
    flex-wrap: wrap;
    max-width: 1000px;
    justify-content: center;
  }
  .main_members {
    position: absolute;
    display: flex;
    flex-direction: column;
  }
</style>



// WEBPACK FOOTER //
// src/components/HomeView.vue